import { render } from "./CreateWorkloadDialog.vue?vue&type=template&id=7e05867b&scoped=true"
import script from "./CreateWorkloadDialog.vue?vue&type=script&lang=js"
export * from "./CreateWorkloadDialog.vue?vue&type=script&lang=js"

import "./CreateWorkloadDialog.vue?vue&type=style&index=0&id=7e05867b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e05867b"]])

export default __exports__